var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeactivatedAvatar = function SvgDeactivatedAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.484 6.457A26.89 26.89 0 0 1 27 0c14.904 0 27 12.096 27 27a26.89 26.89 0 0 1-6.457 17.516l-5.368-5.369c.362-.45.704-.918 1.025-1.401-.055-3.633-4.985-6.155-9.834-7.407l-6.045-6.045A8.089 8.089 0 0 0 35.1 16.2 8.09 8.09 0 0 0 27 8.1a8.089 8.089 0 0 0-8.094 7.779L9.484 6.457Zm-5.319 6.136 17.496 17.496c-5.158 1.146-10.802 3.764-10.861 7.657 3.483 5.238 9.45 8.694 16.2 8.694 3.192 0 6.209-.773 8.87-2.142l5.537 5.537A26.863 26.863 0 0 1 27 54C12.096 54 0 41.904 0 27a26.863 26.863 0 0 1 4.165-14.407Z",
    fill: "#000",
    fillRule: "evenodd",
    fillOpacity: 0.7
  })));
};

export default SvgDeactivatedAvatar;